module.exports = __webpack_public_path__ + "media/grandblvd.acae207f.mp4";